import { render, staticRenderFns } from "./BestSellingSection.vue?vue&type=template&id=0981037d&"
import script from "./BestSellingSection.vue?vue&type=script&lang=js&"
export * from "./BestSellingSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports